export const TRXNS_SMART_CSV_ANALYTICS = {
  BANK_STATEMENT: "transactions download bank statement clicked",
  RAW_CSV: "transactions download csv clicked",
  CUSTOM_CSV: "Click on download Custom CSV",
};
